import '../static/DefaultCard.css';
import React__default from "react";
import clsx from "clsx";
import Image from "next/image.js";
import { b as bustMediaCache } from "./media.DVNzFvj8.mjs";
import { c as Heading } from "./Heading.D9qZoTZe.mjs";
import { b as Paragraph } from "./Paragraph.DAcb0zW2.mjs";
import { b as TextLink } from "./TextLink.gdbulXZb.mjs";
import { C as Card } from "./Card.BpXboJlO.mjs";
const linkCard = `_linkCard_d4d25c3`;
const truncate = `_truncate_94605ef`;
const titleWrap = `_titleWrap_6e4977f`;
const title = `_title_d572388`;
const spacer = `_spacer_ae43fc2`;
const description = `_description_aa6b470`;
const imageWrap = `_imageWrap_e832885`;
const offsetImage = `_offsetImage_57644a2`;
const image = `_image_566f65c`;
const cover = `_cover_e050d7a`;
const contain = `_contain_f9b9232`;
const link = `_link_5b8d992`;
const linkOffset = `_linkOffset_d52c781`;
const center = `_center_cf9c8b7`;
const styles = { linkCard, truncate, titleWrap, title, spacer, description, imageWrap, offsetImage, image, cover, contain, link, linkOffset, center };
const DEFAULT_CARD_ALIGNMENTS = ["left", "center"];
const DEFAULT_CARD_IMAGE_FIT = ["cover", "contain"];
const DefaultCard = ({
  background = true,
  className,
  description: description2,
  title: title2,
  image: image2,
  imageFit = "cover",
  textLink,
  xAlign = "left",
  ...props
}) => {
  const {
    url: imageUrl,
    alternativeText,
    updatedAt,
    ...imageProps
  } = image2 || {};
  const { label, href, target, ...textLinkProps } = textLink || {};
  return /* @__PURE__ */ React__default.createElement(
    Card,
    {
      ...props,
      href,
      target,
      "data-ui": "default-card",
      "data-button-group": true,
      className: clsx(styles[xAlign], { [styles.linkCard]: href }, className),
      hasHoverEffect: !!href,
      hasBackground: background,
      hasPadding: background
    },
    imageUrl && /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: clsx(
          { [styles.offsetImage]: background, [styles.linkCard]: href },
          styles.imageWrap
        )
      },
      /* @__PURE__ */ React__default.createElement(
        Image,
        {
          ...imageProps,
          className: clsx(styles.image, styles[imageFit]),
          src: bustMediaCache(imageUrl, updatedAt),
          alt: alternativeText || "",
          fill: true,
          sizes: "(max-width: 639px) 100vw, (max-width: 991px) 50vw, 640px"
        }
      )
    ),
    title2 && /* @__PURE__ */ React__default.createElement(
      Heading,
      {
        as: "p",
        size: "lg",
        "data-testid": "ui-default-card-title",
        className: clsx(styles.title, {
          [styles.spacer]: !!description2
        })
      },
      title2
    ),
    description2 && /* @__PURE__ */ React__default.createElement(
      Paragraph,
      {
        className: styles.description,
        "data-testid": "ui-default-card-description"
      },
      description2
    ),
    !!href && /*  @ts-expect-error: TextLink requires href prop. Here we're passing it as a prop to the Card component and rendering the TextLink component inside the Card component as a span */
    /* @__PURE__ */ React__default.createElement(
      TextLink,
      {
        ...textLinkProps,
        as: "span",
        arrow: "right",
        className: clsx(styles.link, { [styles.linkOffset]: !!background }),
        "data-testid": "ui-default-card-link"
      },
      label
    )
  );
};
export {
  DEFAULT_CARD_ALIGNMENTS,
  DEFAULT_CARD_IMAGE_FIT,
  DefaultCard
};
//# sourceMappingURL=DefaultCard.DNlsEQg9.mjs.map
